import { useMemo } from 'react';
import { useAuthState } from 'state';
import { DisputeQueue } from 'types';
import ApiService from './ApiService';

export class QueueService extends ApiService {
    
    async getQueues(): Promise<DisputeQueue[]> {
        const { data, status } = await this.get('/api/queues');
        return this.IsSuccessStatusCode(status) ? data : [];
    }
}

export const useQueueService = () => {
    const auth = useAuthState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(() => new QueueService(), [auth]);
};